import { render, staticRenderFns } from "./YoutubeFeed.vue?vue&type=template&id=b15abc46&"
import script from "./YoutubeFeed.vue?vue&type=script&lang=js&"
export * from "./YoutubeFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lili/Sites/southern-highlands.com.au-2018/web/app/themes/wisdom/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('b15abc46', component.options)
    } else {
      api.reload('b15abc46', component.options)
    }
    module.hot.accept("./YoutubeFeed.vue?vue&type=template&id=b15abc46&", function () {
      api.rerender('b15abc46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/YoutubeFeed.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/YoutubeFeed.vue
// module id = 59
// module chunks = 7 9